import api from 'axios'
import { URL_BACK } from '../../variableProd'
/**
 * Servicio para las tiendas
 * @module ServicioUsuarios
 */

const getStores = URL_BACK + '/tiendas/getStores.php'
const update = URL_BACK + '/tiendas/update.php'
const alta = URL_BACK + '/tiendas/alta.php'

/**
 * Funciones para autenticación y administración de tiendas.
 */

export default {
  
  /**
   * Alta un nuevo producto.
   * @param {object} model - Modelo de registro de producto.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  alta (model) {
    return new Promise((resolve, reject) => {
      api
        .post(alta, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Update un nuevo usuario.
   * @param {object} model - Modelo de Update de usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  update (model) {
    return new Promise((resolve, reject) => {
      api
        .post(update, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Obtiene lista de Tiendas.
   * @param {object} model - Modelo de obtener a usuarios.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  getStores (model) {
    return new Promise((resolve, reject) => {
      api
        .post(getStores, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
}

